export class ConfirmAuthorizationDto {
  authorizationIds: number[] = [];
  userId = ''
}
